export default "__VITE_ASSET__8609891d__"